/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import { getPagesFromContext, markBlockAsDeprecated } from "../../helpers";

function defineBlock(formPages) {
    return {
        init: function () {
            markBlockAsDeprecated(this);
            this.appendDummyInput()
                .appendField("navigate to ")
                .appendField(new Blockly.FieldDropdown(formPages), "TOPAGE");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Navigate to a new page in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let toPage = block.getFieldValue('TOPAGE').split('<<<>>>').slice(-1);

            let code = (
                'if (appWidgetMetaData[\'' + toPage + '\']) {\n' +
                'if (appWidgetMetaData[\'' + toPage + '\'].widgetType == "webpage") {\n' +
                'appContextModule.pushIntoNavigationStack(\'' + toPage + '\');\n' +
                'webPageModule.openWebPage(\'' + toPage + '\');\n' +
                '} else {\n' +
                'var navEvent = new navigateEventService();\n' +
                'navEvent.executeNavigate(\'' + toPage + '\');\n' +
                '} }\n'
            )

            return code;
        }
    }
}

const SnapActionNavigate = function (props) {
    let name = "snap_action_navigate";
    SnapActionNavigate.blockName = name;

    const formPages = getPagesFromContext(props.context);
    if (formPages.length === 0) {
        return null;
    }

    Blockly.Blocks[name] = defineBlock(formPages);

    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return (
        <block type={name}></block>
    );
};

SnapActionNavigate.propTypes = {
    context: PropTypes.object.isRequired,
};

export default SnapActionNavigate;
